import APIController from '../core-api-controller';

export const fetchPatientOrdersApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/client_user/orders${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchPatientOrderDetailApi = (id = '') => {
  const path = `${APIController.endpointApi}/client_user/orders/${id}`;
  return APIController.getApiCallback(path);
};

export const uploadPackagePhoto = (caseId, data = {}) => {
  const path = `${APIController.endpointApi}/client_user/cases/${caseId}/upload_delivery_proof`;
  return APIController.postCallback(path, data);
};

export const orderVoucherApi = (id = '') => {
  const path = `${APIController.endpointApi}/client_user/orders/${id}/fetch_voucher`;
  return APIController.getApiCallback(path);
};
